




const path ='https://www.retargetpal.com/assets/images/'
export const IMAGES={
    logo:`${path}logo-with-cericle.svg`,
    target:`${path}second-section.png`,
    blueWave:`${path}blue-wave.svg`,
    ad:`${path}/ad_qood_q.png`,
    envelope:`${path}/bubble-envelope.svg`,
    clock:`${path}/clipboard-clock.svg`,
    graphBoard:`${path}/graph-board.svg`,
    magnet:`${path}/magnet_good_q.png`,
    speaker:`${path}/speaker_qood_q.png`,
    treeNodes:`${path}/tree-nodes.svg`,
    dollarScroll:`${path}/dollar-scroll.svg`,
    speaker2:`${path}/speaker.svg`,
    arrow:`${path}/one_arrow.svg`,
    twoArrows:`${path}/two_arrows.svg`
}